import { Routes, Route, Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatbotWidget from './components/ChatbotWidget';
import Home from './pages/Home';
import Story from './pages/Story';
import Products from './pages/Products';
import SaleOffers from './pages/SaleOffers';
import Contact from './pages/Contact';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import OrdersAdmin from './pages/admin/OrdersAdmin';
import ProductsAdmin from './pages/admin/ProductsAdmin';
import CombosAdmin from './pages/admin/CombosAdmin';
import PromotionsAdmin from './pages/admin/PromotionsAdmin';
import OffersAdmin from './pages/admin/OffersAdmin';
import ContentAdmin from './pages/admin/ContentAdmin';
import SocialAdmin from './pages/admin/SocialAdmin';
import DocsAdmin from './pages/admin/DocsAdmin';
import SalePushAdmin from './pages/admin/SalePushAdmin';
import ShiftsAdmin from './pages/admin/ShiftsAdmin';
import AttendanceAdmin from './pages/admin/AttendanceAdmin';
import ChecklistAdmin from './pages/admin/ChecklistAdmin';
import LayoutAdmin from './pages/admin/LayoutAdmin';

function PublicLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
      <ChatbotWidget />
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/story" element={<Story />} />
        <Route path="/products" element={<Products />} />
        <Route path="/sale" element={<SaleOffers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="orders" element={<OrdersAdmin />} />
        <Route path="products" element={<ProductsAdmin />} />
        <Route path="combos" element={<CombosAdmin />} />
        <Route path="promotions" element={<PromotionsAdmin />} />
        <Route path="offers" element={<OffersAdmin />} />
        <Route path="content" element={<ContentAdmin />} />
        <Route path="social" element={<SocialAdmin />} />
        <Route path="docs" element={<DocsAdmin />} />
        <Route path="sale-push" element={<SalePushAdmin />} />
        <Route path="shifts" element={<ShiftsAdmin />} />
        <Route path="attendance" element={<AttendanceAdmin />} />
        <Route path="checklist" element={<ChecklistAdmin />} />
        <Route path="layout" element={<LayoutAdmin />} />
      </Route>
    </Routes>
  );
}
